// ==============================|| OVERRIDES - MENU ||============================== //

export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: '8px',
          marginTop: '4px',
          boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.1)'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          margin: '4px 8px',
          '&:hover': {
            backgroundColor: theme.palette.secondary.lighter
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.secondary.lighter,
            '&:hover': {
              backgroundColor: theme.palette.secondary.light
            }
          }
        }
      }
    }
  };
}
